import type { HbmlElementNode } from "@holibob-packages/hbml";

export function HbmlUnknownSilentNode({ content }: { content: HbmlElementNode }) {
    console.warn(`Unsupported node of type: ${String(content.type)}`, content);
    return null;
}
